/**
 * Search input + organisation filter for User Management.
 *
 * Extracted from UserManagementPage.tsx (Sub-PR 6.3).
 */

import { useTranslation } from 'react-i18next'
import { Search, Filter } from 'lucide-react'
import type { UserManagementOrganisation } from './types'

interface UserSearchBarProps {
  searchQuery: string
  setSearchQuery: (q: string) => void
  filterOrg: string
  setFilterOrg: (id: string) => void
  showOrgFilter: boolean
  organisations: UserManagementOrganisation[]
}

export function UserSearchBar({
  searchQuery,
  setSearchQuery,
  filterOrg,
  setFilterOrg,
  showOrgFilter,
  organisations,
}: UserSearchBarProps): React.ReactElement {
  const { t } = useTranslation('admin')

  return (
    <div className="flex flex-col gap-4 sm:flex-row">
      <div className="relative flex-1">
        <Search className="absolute top-1/2 left-3 h-5 w-5 -translate-y-1/2 text-stone-400" />
        <input
          type="text"
          placeholder={t('users.searchPlaceholder')}
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value)
          }}
          className="w-full rounded-lg border border-stone-200 bg-white py-2 pr-4 pl-10 focus:ring-2 focus:ring-[#4e5e82] focus:outline-none dark:border-stone-700 dark:bg-stone-800"
        />
      </div>
      {showOrgFilter && organisations.length > 0 && (
        <div className="relative">
          <Filter className="absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-stone-400" />
          <select
            value={filterOrg}
            onChange={(e) => {
              setFilterOrg(e.target.value)
            }}
            className="min-w-[200px] appearance-none rounded-lg border border-stone-200 bg-white py-2 pr-8 pl-9 text-stone-900 focus:ring-2 focus:ring-[#4e5e82] focus:outline-none dark:border-stone-700 dark:bg-stone-800 dark:text-stone-100"
          >
            <option value="">{t('users.allOrganisations')}</option>
            {organisations.map((org) => (
              <option key={org.id} value={org.id}>
                {org.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  )
}
